import { useMemo } from "react";
import { PlanTableFormat } from "../types/planning/plan.type";

/**
 * Returns true if a route with status 'DEPT' and at least one shipment in 'DLVR' status is immutable (no updates allowed).
 */
/**
 * Pure function to determine if a route is immutable: DEPT status + any DLVR shipment
 */
export function isRouteImmutablePure(
  routeStatus: string | null | undefined,
  shipments: Array<{ status: string }> | null | undefined
): boolean {
  return (
    routeStatus === "DEPT" &&
    Array.isArray(shipments) &&
    shipments.some((s) => s.status === "DLVR")
  );
}

export function isRouteClosedForSequencing(route: PlanTableFormat[]): boolean {
  if (route.length === 0) return false;
  return route.some((r) => ["CLDV", "DISP", "DEPT"].includes(r.status));
}

/**
 * Hook version: applies the immutability logic
 */
export function useIsRouteImmutable(
  routeStatus: string | null | undefined,
  shipments: Array<{ status: string }> | null | undefined
): boolean {
  return useMemo(
    () => isRouteImmutablePure(routeStatus, shipments),
    [routeStatus, shipments]
  );
}
